<script setup>
/* Fortschritt und Notknopf des Teilens, Teil der Auswahlleiste (SelectionBar.vue).
   Fortschritt "Loading 3 of 12" mit Cancel; nach abgelaufener Berührung der Knopf "Share {n} files". */
import { useShareFiles } from '../composables/useShareFiles.js';

const emit = defineEmits(['share-now']);
const { busy, progress, pending, cancel, dismissPending } = useShareFiles();
</script>

<template>
  <div v-if="busy || pending" class="share-status" role="status" aria-live="polite" data-testid="share-status">
    <template v-if="busy">
      <span class="share-text">
        {{ progress ? $t('selection.loadingProgress', { done: progress.done, total: progress.total }) : $t('common.loading') }}
      </span>
      <button type="button" class="btn ghost share-btn" data-testid="share-cancel" @click="cancel">
        {{ $t('common.cancel') }}
      </button>
    </template>
    <template v-else-if="pending">
      <button type="button" class="btn share-btn" data-testid="share-now" @click="emit('share-now')">
        {{ $t('selection.shareNow', { count: pending.length }, pending.length) }}
      </button>
      <button type="button" class="btn ghost share-btn" data-testid="share-dismiss" @click="dismissPending">
        {{ $t('common.cancel') }}
      </button>
    </template>
  </div>
</template>

<style scoped>
.share-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  flex-basis: 100%;
}
.share-text {
  font-size: 13px;
  color: var(--muted);
}
.share-btn {
  min-height: 40px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 500;
}
</style>
